import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  GeneralAdminRoutes,
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../../constants";
import {
  FilterSection,
  GAOrganizationsTable,
  SearchBar,
} from "../../components/components";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import {
  deleteOrganization,
  getDateRange,
  getFilterOrganizations,
  organizationSearch,
  updateOrganization,
} from "../../../../../modules/OrgProf/hook/Organizationhook";
import { Toast } from "../../../../../common/alert";
import { useAuth } from "../../../../../hooks";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import FilterModalComponent from "../../../../../common/FilterModalComponent";

const GAOrganizationsContainer = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const { handleGetAllOrganizations, allOrganization, setLoading, loading } =
    useOrganizationContext();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );
  const [organizationData, setOrganizationData] = useState([]);

  // console.log("organizationData", organizationData);
  useEffect(() => {
    // if (allOrganization.length) {
    // } else {
    handleGetAllOrganizations();
    // }
  }, []);

  useEffect(() => {
    setOrganizationData(allOrganization);
  }, [allOrganization]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };
  // const handleFilterOrganizations = async () => {

  //   let temp = await getFilterOrganizations(
  //     // whoCanListenFilterOptions,

  //     creationDateFilterOptions,
  //     statusFilterOptions,
  //     setLoading,
  //     handleFilterModalClose
  //   );
  //   // console.log("filter data:", temp);
  //   setOrganizationData([...temp]);
  //   if (
  //     creationDateFilterOptions.length === 0 &&
  //     statusFilterOptions.length === 0
  //   ) {
  //     console.log("org. data:", allOrganization);
  //     setOrganizationData([]);
  //   }
  // };
  const handleFilterOrganizations = async () => {
    let dateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      dateRange = getDateRange(creationDateFilterOptions, "Creation Date");
    }
    setSelected([]);
    if (
      creationDateFilterOptions.length > 0 ||
      statusFilterOptions.length > 0
    ) {
      let temp = await getFilterOrganizations(
        dateRange,
        statusFilterOptions,
        setLoading,
        handleFilterModalClose
      );
      setOrganizationData([...temp]);
    }
    if (
      creationDateFilterOptions.length === 0 &&
      statusFilterOptions.length === 0
    ) {
      console.log("here");
      setOrganizationData(allOrganization);
    }
  };

  const handleSearchOrganizationData = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let organizationSearchTemp = await organizationSearch(
          organizationData,
          value
        );
        setOrganizationData(organizationSearchTemp);
      } else {
        setOrganizationData(allOrganization);
      }
    } catch (error) {
      console.log("error searching album:", error.message);
    }
  };

  const handleUpdateOrganizationStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status: status.toLowerCase(),
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateOrganization(item, dataTemp);
        console.log("update organization response:", responseTemp);
      });
      await handleGetAllOrganizations();
      setSelected([]);
      showNotification("Organization status updated successfully.");
      // Toast("success", "Organization status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating album", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteOrganization = async () => {
    try {
      setLoading(true);

      selected.forEach(async (item) => {
        let responseTemp = await deleteOrganization(item);
        console.log("delete organization response:", responseTemp);
      });
      await handleGetAllOrganizations();
      setSelected([]);
      showNotification("Organization deleted successfully.");
      // Toast("success", "Organization deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting organization", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "creationDate") {
      // setCreationDateFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
      setCreationDateFilterOptions([]);
    }
  };

  useEffect(() => {
    handleFilterOrganizations();
  }, [statusFilterOptions, creationDateFilterOptions]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const resetFilter = async () => {
    setStatusFilterOptions([]);
    setCreationDateFilterOptions([]);
    setOrganizationData(allOrganization);
    setSelected([]);
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header
        mainTitle={"Organizations"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super" || currentUser?.role === "manager"
            ? "Add Organization"
            : undefined
        }
        handleSubmit={() => navigate(GeneralAdminRoutes.addOrganization)}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            creationDateFilterOptions={creationDateFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            setSelected={setSelected}
            handleSearch={handleSearchOrganizationData}
            handleUpdateOrganizationStatus={handleUpdateOrganizationStatus}
            handleDeleteOrganization={handleDeleteModalOpen}
          />
          <GAOrganizationsTable
            selected={selected}
            setSelected={setSelected}
            organizationData={organizationData}
            setOrganizationData={setOrganizationData}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteOrganization}
        title={
          "Are you sure you want to delete the organization(s)? All data will be lost.  You can change the status to “Inactive” to remove it from displaying in the QuickTales app."
        }
        // title={"Are you sure to delete the selected Organization(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterOrganizations}
        data={[
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Account Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Active", selected: false },
              { label: "Inactive", selected: false },
              { label: "Unlisted", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAOrganizationsContainer;
